import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { DeliveryPreferenceService } from './delivery-preference.service';

@Component({
  selector: 'app-delivery-preference',
  templateUrl: './delivery-preference.component.html',
  styleUrls: ['./delivery-preference.component.css'],
})
export class DeliveryPreferenceComponent implements OnInit {
  isLoading = new BehaviorSubject<boolean>(false);
  displayedColumns: string[] = [
    'SNo',
    'delivery_preference',
    'createdAt',
    'updatedAt',
    'status',
    'action',
  ];
  bucketurl = environment.bucketUrl;
  public ELEMENT_DATA: any[] = [];
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public selectedId: number | null = null;
  deliveryPreference: FormGroup;
  dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);

  constructor(
    private deliveryPreferenceService: DeliveryPreferenceService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.deliveryPreference = this.fb.group({
      status: ['', Validators.required],
      delivery_preference: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.getDeliveryPreferenceList();
  }

  getDeliveryPreferenceList() {
    this.isLoading.next(true);
    this.deliveryPreferenceService.getDeliveryPreference().subscribe(
      (response) => {
        this.ELEMENT_DATA = response.body.data;
        this.dataSource.data = this.ELEMENT_DATA;
        this.isLoading.next(false);
      },
      (error) => {
        this.isLoading.next(false);
      }
    );
  }

  onSubmit() {
    this.submitted = true;

    if (this.deliveryPreference.invalid) {
      return;
    }

    this.isLoading.next(true);

    if (this.isEdit) {
      if (this.selectedId !== null) {
        this.deliveryPreferenceService
          .updateDeliveryPreference(
            this.selectedId,
            this.deliveryPreference.value
          )
          .subscribe(
            (response) => {
              let responseData = response.body;
              if (responseData.responseCode == 200) {
              this.toastr.success('Delivery Preference updated successfully');
              this.clearForm();
              this.isEdit = false;
              this.getDeliveryPreferenceList();
              this.isLoading.next(false);
              }else {
                this.isLoading.next(false);
                this.toastr.error(responseData.responseMessage)
              }
            },
            (error) => {
              this.toastr.error('Error updating Delivery Preference');
              this.isLoading.next(false);
            }
          );
      }
    } else {
      this.deliveryPreferenceService
        .createDeliveryPreference(this.deliveryPreference.value)
        .subscribe(
          (response) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
            this.toastr.success('Delivery Preference created successfully');
            this.clearForm();
            this.isCreate = false;
            this.getDeliveryPreferenceList();
            this.isLoading.next(false);
            } else {
              this.isLoading.next(false);
              this.toastr.error(responseData.responseMessage)
            }
          },
          (error) => {
            this.toastr.error('Error creating Delivery Preference');
            this.isLoading.next(false);
          }
        );
    }
  }

  edit(element: any) {
    this.isEdit = true;
    this.isCreate = false;
    this.selectedId = element.id;
    this.deliveryPreference.patchValue({
      status: element.status ? 1 : 0,
      delivery_preference: element.delivery_preference,
    });
  }

  clearForm() {
    this.submitted = false;
    this.deliveryPreference.patchValue({
      status: '',
      delivery_preference: '',
    });
    this.selectedId = null;
  }

  back() {
    this.clearForm();
    this.isCreate = false;
    this.isEdit = false;
    this.getDeliveryPreferenceList();
  }
}
